import { Box, CircularProgress, styled, Typography } from '@mui/material';

export const DashboardContainer = styled(Box)({
  width: '100%',
  height: '100vh',
  display: 'flex'
});

export const CenteredBox = styled(Box)({
  display: 'flex',
  margin: 'auto',
  flexDirection: 'column',
  alignItems: 'center'
});

export const Spinner = styled((props: any) => {
  return (
    <CenteredBox {...props}>
      <CircularProgress sx={{ width: '64px', height: '64px' }} style={{ width: '64px', height: '64px' }} />
      <Typography sx={{ marginTop: '20px', fontSize: '1.2rem' }}>Loading...</Typography>
    </CenteredBox>
  );
})(() => ({}));

export const Message = styled((props: any) => {
  return (
    <CenteredBox {...props}>
      <Typography sx={{ fontSize: '1.2rem' }}>{props.text}</Typography>
    </CenteredBox>
  );
})(() => ({}));
